<template>
  <b-form-input v-model="item" mask='###,###,###,###,###' :placeholder="placeholder" :disabled="disabled"></b-form-input>
</template>
<script>
export default {
  name: "NumberSeprator",
  props: ["value","placeholder","disabled"],
  data() {
    return {
      item: null,
       persianNumbers : [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
       arabicNumbers  : [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      if (this.item != null) {
        if (newVal != this.item.split(",").join("")) {
          this.item = newVal;
        }
      } else {
        this.item = newVal;
      }
    },
    item: function (newVal, oldVal) {
      var number = 0;
      if (this.item != null)
        var number = this.item.toString().split(",").join("");
      number=this.fixNumbers(number)
      this.item = this.thousandSeprator(parseInt(!isNaN(number) ? number : 0));
      this.$emit("input", parseInt(number));
    },
  },
  created() {
    if (this.value) {
      this.item = this.value;
    }
  },
  methods: {
    preventForNonNmber(event) {
      console.log(event.keyCode);
      if ((event.keyCode< 96 || event.keyCode > 105) && event.keyCode != 8 && event.keyCode != 9 && event.keyCode != 46) {
        event.preventDefault();
      }
    },
    thousandSeprator(amount) {
      amount=this.fixNumbers(amount)
      if (
        amount !== "" ||
        amount !== undefined ||
        amount !== 0 ||
        amount !== "0" ||
        amount !== null
      ) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return amount;
      }
    },
    fixNumbers(str){
          if(typeof str === 'string')
          {
            for(var i=0; i<str.length; i++)
            {
              str = str.replace(this.persianNumbers[i], i).replace(this.arabicNumbers[i], i);
            }
          }
          return str;
        }
  },
};
</script>